module.exports = __webpack_public_path__ + "img/medical-background.125a8d2a.svg";